/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [赔付首页-列表↗](http://yapi.yishou.com/project/128/interface/api/33530) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/getIndexList`
 * @更新时间 `2022-05-11 11:20:17`
 */
const getIndexListRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/getIndexList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        title: "empty object",
        properties: {
            pf_no: { type: "string", description: "赔付单号" },
            pgid: { type: "number", description: "采购组id" },
            supply_name: { type: "string", description: "供应商名称" },
            storehouse_id: { type: "number", description: "仓库ID" },
            pf_type: { type: "number", description: "赔付类型" },
            pf_status: { type: "number", description: "赔付状态" },
            pay_tool: { type: "number", description: "支付方式" },
            member_name: { type: "string", description: "采购人名称/仓库名称" },
            is_on_sale: { type: "number", description: "是否包含下架" },
            created_at: { type: "array", items: { type: "string" }, description: "赔付单 创建日期" },
            payment_at: { type: "array", items: { type: "string" }, description: "支付时间" },
            page: { type: "number" },
            pagesize: { type: "number" },
            is_excel: { type: "number" },
            export_ids: { type: "array", items: { type: "string" }, description: "导出id" },
        },
        required: ["created_at"],
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            option_pg: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "string" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
                description: "采购组",
            },
            option_stock: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "string" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
                description: "仓库",
            },
            option_compensate_type: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
                description: "赔付类型",
            },
            option_compensate_paytool: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
                description: "支付方式",
            },
            option_compensate_status: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, label: { type: "string" } },
                    required: ["key", "label"],
                },
                description: "赔付状态",
            },
            option_on_sale: {
                type: "array",
                items: {
                    type: "object",
                    properties: { key: { type: "number" }, laebl: { type: "string" } },
                    required: ["key", "laebl"],
                },
                description: "是否买赔",
            },
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: "赔付id" },
                        pf_no: { type: "string", description: "赔付单号" },
                        pf_created_at: { type: "string", description: "赔付单日期" },
                        pf_type_msg: { type: "string", description: "赔付类型" },
                        pay_tool_msg: { type: "string", description: "支付方式" },
                        supply_name: { type: "string", description: "供应商名称" },
                        city: { type: "string", description: "城市" },
                        market_name: { type: "string", description: "市场" },
                        brand: { type: "string", description: "品牌" },
                        pgname: { type: "string", description: "采购组" },
                        pg_member_name: { type: "string", description: "采购员" },
                        defective_group_member_name: { type: "string", description: "售后退供员" },
                        storehouse_name: { type: "string", description: "仓库" },
                        create_member_name: { type: "string", description: "创建人" },
                        storehouse_member_name: { type: "string", description: "仓库审核人" },
                        storehouse_examine_at: { type: "string", description: "仓库审核时间" },
                        purchase_member_name: { type: "string", description: "采购提交人" },
                        purchase_examine_at: { type: "string", description: "采购提交时间" },
                        goods_num: { type: "string", description: "商品数量" },
                        total_origin_market_price: { type: "number", description: "原拿货总金额" },
                        stock_in_num: { type: "number", description: "入库数量" },
                        total_pf_price: { type: "number", description: "赔付总金额" },
                        diff_price: { type: "number", description: "差额" },
                        status_msg: { type: "string", description: "赔付单状态" },
                        pay_member_name: { type: "string", description: "支付人" },
                        payment_at: { type: "string", description: "支付时间" },
                    },
                    required: [
                        "id",
                        "pf_no",
                        "pf_created_at",
                        "pf_type_msg",
                        "pay_tool_msg",
                        "supply_name",
                        "city",
                        "market_name",
                        "brand",
                        "pgname",
                        "pg_member_name",
                        "defective_group_member_name",
                        "storehouse_name",
                        "create_member_name",
                        "storehouse_member_name",
                        "storehouse_examine_at",
                        "purchase_member_name",
                        "purchase_examine_at",
                        "goods_num",
                        "total_origin_market_price",
                        "stock_in_num",
                        "total_pf_price",
                        "diff_price",
                        "status_msg",
                        "pay_member_name",
                        "payment_at",
                    ],
                },
                description: "列表",
            },
            count: { type: "number", description: "数量" },
        },
    },
    requestFunctionName: "getIndexList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付首页-列表↗](http://yapi.yishou.com/project/128/interface/api/33530) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/getIndexList`
 * @更新时间 `2022-05-11 11:20:17`
 */
export const getIndexList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getIndexListRequestConfig, requestData), ...args);
};
getIndexList.requestConfig = getIndexListRequestConfig;
/**
 * 接口 [赔付首页-导出赔付明细列表↗](http://yapi.yishou.com/project/128/interface/api/33531) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/exportDetailList`
 * @更新时间 `2022-05-10 14:59:05`
 */
const exportDetailListRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/exportDetailList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        title: "empty object",
        properties: { export_ids: { type: "array", items: { type: "string" }, description: "赔付id数组" } },
        required: ["export_ids"],
    },
    responseDataJsonSchema: { type: "object", properties: { file: { type: "string" } } },
    requestFunctionName: "exportDetailList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付首页-导出赔付明细列表↗](http://yapi.yishou.com/project/128/interface/api/33531) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/exportDetailList`
 * @更新时间 `2022-05-10 14:59:05`
 */
export const exportDetailList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportDetailListRequestConfig, requestData), ...args);
};
exportDetailList.requestConfig = exportDetailListRequestConfig;
/**
 * 接口 [赔付详情-列表↗](http://yapi.yishou.com/project/128/interface/api/33532) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/getDetailList`
 * @更新时间 `2022-05-12 13:55:50`
 */
const getDetailListRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/getDetailList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pf_id"],
        properties: { pf_id: { type: "string", description: "赔付单id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            head_data: {
                type: "object",
                properties: {
                    pf_no: { type: "string", description: "赔付单号" },
                    created_at: { type: "string", description: "创建时间" },
                    status: {
                        type: "string",
                        description: "状态数值 {1:采购待提交\\n,2:已作废,3:仓储待审核,4:采购待重新提交,5:待入库,6:财务待支付,7:已完成}",
                    },
                    status_msg: { type: "string", description: "状态描述" },
                    pay_tool: { type: "string", description: "支付方式{0:转账，1:分账}" },
                    total_goods_num: { type: "integer", description: "总数" },
                    total_pf_price: { type: "number", description: "总价格" },
                },
                description: "顶部数据",
            },
            detail_list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: "详情id" },
                        dbid: { type: "string", description: "打标id" },
                        psp_id: { type: "string", description: "前置计划id" },
                        goods_name: { type: "string", description: "商品名称" },
                        goods_img: { type: "string", description: "商品图片" },
                        goods_kh: { type: "string", description: "款号" },
                        goods_no: { type: "string", description: "货号" },
                        co_val: { type: "string", description: "颜色" },
                        si_val: { type: "string", description: "尺码" },
                        sku: { type: "string" },
                        cat_name: { type: "string", description: "分类名称" },
                        stock_source: { type: "string", description: "入库来源" },
                        is_on_sale_msg: { type: "string", description: "商品状态" },
                        exception_source: { type: "string", description: "异常来源" },
                        exception_admin: { type: "string", description: "标记异常人" },
                        exception_time: { type: "string", description: "标记异常时间" },
                        original_market_price: { type: "string", description: "原拿货价" },
                        actual_market_price: { type: "string", description: "实际赔付价" },
                        diff_price: { type: "number", description: "差额" },
                        stock_in_price: { type: "string", description: "入库金额" },
                        new_dbid: { type: "string", description: "新打标ID" },
                        new_stock_source: { type: "string", description: "新入库来源" },
                    },
                    required: [
                        "id",
                        "dbid",
                        "psp_id",
                        "goods_name",
                        "goods_img",
                        "goods_kh",
                        "goods_no",
                        "co_val",
                        "si_val",
                        "sku",
                        "cat_name",
                        "stock_source",
                        "is_on_sale_msg",
                        "exception_source",
                        "exception_admin",
                        "exception_time",
                        "original_market_price",
                        "actual_market_price",
                        "diff_price",
                        "stock_in_price",
                        "new_dbid",
                        "new_stock_source",
                    ],
                },
                description: "详情数组",
            },
            payees: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: "支付id" },
                        pay_contact: { type: "string", description: "收款人名称" },
                        pay_bank: { type: "string", description: "开户行名称" },
                        payee_bank: { type: "string", description: "联行号" },
                        pay_account: { type: "string", description: "账号" },
                        is_default: { type: "string", description: "是否默认" },
                    },
                    required: ["id", "pay_contact", "pay_bank", "payee_bank", "pay_account", "is_default"],
                },
                description: "收款人信息",
            },
            operate_log: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        action_admin: { type: "string", description: "操作人" },
                        action_type: { type: "string", description: "操作方式" },
                        action_result: { type: "string", description: "结果" },
                        create_time: { type: "string", description: "操作时间" },
                        action_desc: { type: "string", description: "备注" },
                    },
                    required: ["action_admin", "action_type", "action_result", "create_time", "action_desc"],
                },
            },
        },
    },
    requestFunctionName: "getDetailList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付详情-列表↗](http://yapi.yishou.com/project/128/interface/api/33532) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/getDetailList`
 * @更新时间 `2022-05-12 13:55:50`
 */
export const getDetailList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getDetailListRequestConfig, requestData), ...args);
};
getDetailList.requestConfig = getDetailListRequestConfig;
/**
 * 接口 [赔付详情-更新实际赔付价格↗](http://yapi.yishou.com/project/128/interface/api/33533) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/updateActualMarketPrice`
 * @更新时间 `2022-05-12 11:35:54`
 */
const updateActualMarketPriceRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/updateActualMarketPrice",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pfd_id", "actual_market_price"],
        properties: {
            pfd_id: { type: "string", description: "赔付单详情id" },
            actual_market_price: { type: "string", description: "实际赔付价" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "updateActualMarketPrice",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付详情-更新实际赔付价格↗](http://yapi.yishou.com/project/128/interface/api/33533) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/updateActualMarketPrice`
 * @更新时间 `2022-05-12 11:35:54`
 */
export const updateActualMarketPrice = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(updateActualMarketPriceRequestConfig, requestData), ...args);
};
updateActualMarketPrice.requestConfig = updateActualMarketPriceRequestConfig;
/**
 * 接口 [赔付详情-作废赔付单↗](http://yapi.yishou.com/project/128/interface/api/33534) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/cancelCompensate`
 * @更新时间 `2022-05-12 15:36:09`
 */
const cancelCompensateRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/cancelCompensate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pf_id", "log_remark"],
        properties: { pf_id: { type: "string" }, log_remark: { type: "string", description: "" } },
    },
    responseDataJsonSchema: { type: "array", items: { type: "string" } },
    requestFunctionName: "cancelCompensate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付详情-作废赔付单↗](http://yapi.yishou.com/project/128/interface/api/33534) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/cancelCompensate`
 * @更新时间 `2022-05-12 15:36:09`
 */
export const cancelCompensate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(cancelCompensateRequestConfig, requestData), ...args);
};
cancelCompensate.requestConfig = cancelCompensateRequestConfig;
/**
 * 接口 [赔付详情-采购提交赔付单↗](http://yapi.yishou.com/project/128/interface/api/33535) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/purchaseAdoptCompensate`
 * @更新时间 `2022-05-12 12:24:43`
 */
const purchaseAdoptCompensateRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/purchaseAdoptCompensate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pf_id", "payee_id"],
        properties: {
            pf_id: { type: "string", description: "赔付单id" },
            log_remark: { type: "string", description: "日志备注" },
            payee_id: { type: "string", description: "收款信息id ，分支支付也需要传" },
        },
    },
    responseDataJsonSchema: { type: "array", items: { type: "string" } },
    requestFunctionName: "purchaseAdoptCompensate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付详情-采购提交赔付单↗](http://yapi.yishou.com/project/128/interface/api/33535) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/purchaseAdoptCompensate`
 * @更新时间 `2022-05-12 12:24:43`
 */
export const purchaseAdoptCompensate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(purchaseAdoptCompensateRequestConfig, requestData), ...args);
};
purchaseAdoptCompensate.requestConfig = purchaseAdoptCompensateRequestConfig;
/**
 * 接口 [赔付详情-仓储通过赔付单↗](http://yapi.yishou.com/project/128/interface/api/33536) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/storehouseAdoptCompensate`
 * @更新时间 `2022-05-17 11:37:54`
 */
const storehouseAdoptCompensateRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/storehouseAdoptCompensate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pf_id", "log_remark"],
        properties: { pf_id: { type: "string", description: "赔付id" }, log_remark: { type: "string", description: "" } },
    },
    responseDataJsonSchema: { type: "array", items: { type: "string" } },
    requestFunctionName: "storehouseAdoptCompensate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付详情-仓储通过赔付单↗](http://yapi.yishou.com/project/128/interface/api/33536) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/storehouseAdoptCompensate`
 * @更新时间 `2022-05-17 11:37:54`
 */
export const storehouseAdoptCompensate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(storehouseAdoptCompensateRequestConfig, requestData), ...args);
};
storehouseAdoptCompensate.requestConfig = storehouseAdoptCompensateRequestConfig;
/**
 * 接口 [赔付详情-仓储驳回赔付单↗](http://yapi.yishou.com/project/128/interface/api/33537) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/rejectCompensate`
 * @更新时间 `2022-05-13 10:01:33`
 */
const rejectCompensateRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/rejectCompensate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pf_id", "log_remark"],
        properties: { pf_id: { type: "string" }, log_remark: { type: "string", description: "" } },
    },
    responseDataJsonSchema: { type: "array", items: { type: "string" } },
    requestFunctionName: "rejectCompensate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付详情-仓储驳回赔付单↗](http://yapi.yishou.com/project/128/interface/api/33537) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/rejectCompensate`
 * @更新时间 `2022-05-13 10:01:33`
 */
export const rejectCompensate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(rejectCompensateRequestConfig, requestData), ...args);
};
rejectCompensate.requestConfig = rejectCompensateRequestConfig;
/**
 * 接口 [赔付详情-打标-赔付打标↗](http://yapi.yishou.com/project/128/interface/api/33550) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/goodsCompensate/pFDaBiao`
 * @更新时间 `2022-05-11 16:07:05`
 */
const pFDaBiaoRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/goodsCompensate/pFDaBiao",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pf_id"],
        properties: {
            pf_id: { type: "string", description: "赔付id" },
            dbid: { type: "string", description: "旧的dbid，可为空，为空则显示数量和已打标数据" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            dbidCount: { type: "number", description: "打标数量" },
            newDbid: { type: "array", items: { type: "string" }, description: "新打标id" },
        },
    },
    requestFunctionName: "pFDaBiao",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付详情-打标-赔付打标↗](http://yapi.yishou.com/project/128/interface/api/33550) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/goodsCompensate/pFDaBiao`
 * @更新时间 `2022-05-11 16:07:05`
 */
export const pFDaBiao = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(pFDaBiaoRequestConfig, requestData), ...args);
};
pFDaBiao.requestConfig = pFDaBiaoRequestConfig;
/**
 * 接口 [赔付详情-提交打标数据并入库↗](http://yapi.yishou.com/project/128/interface/api/33551) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/submitDbid`
 * @更新时间 `2022-05-11 16:39:32`
 */
const submitDbidRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/submitDbid",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["pf_id"],
        properties: { pf_id: { type: "string", description: "赔付id" } },
    },
    responseDataJsonSchema: { type: "array", items: { type: "string" } },
    requestFunctionName: "submitDbid",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付详情-提交打标数据并入库↗](http://yapi.yishou.com/project/128/interface/api/33551) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/submitDbid`
 * @更新时间 `2022-05-11 16:39:32`
 */
export const submitDbid = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(submitDbidRequestConfig, requestData), ...args);
};
submitDbid.requestConfig = submitDbidRequestConfig;
/**
 * 接口 [赔付详情-打标-撤标↗](http://yapi.yishou.com/project/128/interface/api/33552) 的 **请求配置**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/removeDbid`
 * @更新时间 `2022-05-11 16:23:10`
 */
const removeDbidRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GoodsCompensate/removeDbid",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["new_dbid"],
        properties: { new_dbid: { type: "string", description: "新打标id，可以是数组 也可以是单个打标id" } },
    },
    responseDataJsonSchema: { type: "array", items: { type: "string" } },
    requestFunctionName: "removeDbid",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [赔付详情-打标-撤标↗](http://yapi.yishou.com/project/128/interface/api/33552) 的 **请求函数**
 *
 * @分类 [前置仓买赔↗](http://yapi.yishou.com/project/128/interface/api/cat_3155)
 * @请求头 `POST /erp/GoodsCompensate/removeDbid`
 * @更新时间 `2022-05-11 16:23:10`
 */
export const removeDbid = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(removeDbidRequestConfig, requestData), ...args);
};
removeDbid.requestConfig = removeDbidRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/goodsCompensate.js